import React from "react";

const NewComponent = ({ foo }) => {
  return <div>New Component: {foo}</div>;
};

export default NewComponent;
